import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import { ab_test_variant } from "../../config/apiEndpoints";
import { keyMapsMutation } from "../../helpers/storeKeys";
import { keyMapsAction as keyMapsActionPayment } from "../../helpers/paymentHelpers/storeKeys";
import {
  EVENT_CLICK_ADDTOCART,
  EVENT_CLICK_REMOVEFROMCART,
  EVENT_CLICK_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION_COMBO,
  EVENT_CLICK_EDITITEMINCART,
  EVENT_CLICK_COMBO_ADD,
  EVENT_CLICK_COMBO_REMOVE,
  EVENT_CLICK_CARTUPSELL_ADD,
  EVENT_ADVANCE_ORDER_CLICK,
} from "../../helpers/analyticsEvents";

import { CartErrorMessages } from "../../helpers/messageConstants";
import { PRICE_AFTER_DEDUCTIONS_KEY } from "../../helpers/cartConstants";

const getIndexOfItemFromCartForRemoval = (item, itemArray) => {
  let itemsInGivenComboItem = new Set();
  if (item.comboUID) {
    item?.selectedComboVariant?.map((comboVariant) => {
      comboVariant?.items?.map((i) => itemsInGivenComboItem.add(i.parentSkuId));
    });
  }

  for (let i = 0; i < itemArray.length; i++) {
    if (item.comboUID) {
      let itemsInComboItemFromItemArray = new Set();
      itemArray[i]?.selectedComboVariant?.map((comboVariant) => {
        comboVariant.items?.map((i) =>
          itemsInComboItemFromItemArray.add(i.parentSkuId)
        );
      });
      if (
        Utility.areSetsEqual(
          itemsInGivenComboItem,
          itemsInComboItemFromItemArray
        )
      ) {
        return i;
      }
    } else if (
      item?.selectedVariant?.skuId == itemArray[i]?.selectedVariant?.skuId
    ) {
      return i;
    }
  }
  return 0;
};

const deDuplicatedItems = (item) => {
  let itemSelectedVariants = new Set();
  let result = {};
  item.forEach((itm) => {
    if (!itemSelectedVariants.has(itm.selectedVariant?.skuId)) {
      result[itm.selectedVariant?.skuId] = itm;
      itemSelectedVariants.add(itm.selectedVariant?.skuId);
    }
  });
  return result;
};

const deDeuplicatedCombos = (item) => {
  let itemSelectedComboVariants = new Set();
  let result = {};
  item.forEach((itm) => {
    let iSelectedComboVariants = [];
    itm?.selectedComboVariant?.map((comboVariant) => {
      comboVariant?.items?.map((i) =>
        iSelectedComboVariants.push(i.productMasterId)
      );
    });

    iSelectedComboVariants.sort();
    iSelectedComboVariants = iSelectedComboVariants.join("");

    if (!itemSelectedComboVariants.has(iSelectedComboVariants)) {
      result[iSelectedComboVariants] = itm;
      itemSelectedComboVariants.add(iSelectedComboVariants);
    }
  });
  return result;
};

const getPriceOfOneCartItem = (item) => {
  if (item.comboUID) {
    let sum = 0;
    item?.selectedComboVariant?.map((comboVariant) => {
      comboVariant?.items?.map((item) => {
        sum += item?.products[0]?.price?.currentPrice || 0;
      });
    });
    return sum;
  } else if (item.selectedVariant?.price?.currentPrice) {
    return item.selectedVariant?.price?.currentPrice;
  } else if (
    item?.variants?.find((x) => x.defaultVariant)?.price?.currentPrice
  ) {
    return item?.variants?.find((x) => x.defaultVariant)?.price?.currentPrice;
  }
};

const getCartItemsPayload = (items, getters) => {
  let cartItems = [];
  Object.keys(items)
    .map((skuId) => {
      let sepVariants = getters.getSeparateVariants(skuId);
      sepVariants &&
        Object.values(sepVariants)?.map((productItemDetail) => {
          let cartItem = {};
          if (productItemDetail?.parentSkuId) {
            cartItem.quantity =
              getters.getIndividualQuantity(productItemDetail);
            cartItem.skuId = productItemDetail?.selectedVariant?.skuId;
            cartItem.productMetadata = {
              productMenuMetadata: {
                menuType: productItemDetail?.menuType,
              },
            };
          } else {
            cartItem.quantity =
              getters.getIndividualQuantity(productItemDetail);
            cartItem.skuId = Utility.getComboSkuId(productItemDetail);
            cartItem.productMetadata = {
              productMenuMetadata: {
                menuType: productItemDetail?.menuType,
              },
            };

            let childItems = [];
            productItemDetail?.selectedComboVariant?.map((y) => {
              y?.items.map((z) => {
                let childItem = {};
                childItem.parentSkuId = productItemDetail?.skuId;
                childItem.productMetadata = {
                  productMenuMetadata: {
                    menuType: productItemDetail?.menuType,
                  },
                };
                childItem.quantity = z.products.length;
                childItem.skuId = z.products[0].skuId;
                childItem.groupId = y.groupUID;
                childItems.push(childItem);
              });
            });
            cartItem.childItems = childItems;
          }
          cartItems.push(cartItem);
        });
    })
    .flat();

  return cartItems;
};

const getCartTotalFunc = (items) => {
  let sum = 0;
  for (const property in items) {
    if (items[property] && items[property]?.length) {
      for (const stateItemProperty of items[property]) {
        let priceOfOneCartItem = getPriceOfOneCartItem(stateItemProperty);
        if (!isNaN(priceOfOneCartItem)) {
          sum += priceOfOneCartItem;
        }
      }
    }
  }
  return parseFloat(sum.toFixed(2));
};

const cartResultItemsPriceSet = (product) => {
  let result = {};
  let key = product.comboUID;
  product?.groups?.map((x) => {
    x.comboItems?.map((i) => {
      key = key + "#" + i.productUID;
    });
  });
  result[key] = product.price;
  return result;
};

const cartItemsPriceSetKey = (product) => {
  let key = product.comboUID;
  product?.selectedComboVariant?.map((x) => {
    x.items?.map((i) => {
      key = key + "#" + i.products[0].productID;
    });
  });
  return key;
};

// const getItemsbySkuId =(items,validItems) =>{
//   let cartItems = {};
//   let validSkuIds = [];
//   validItems.map((item)=> validSkuIds.push(item.skuId));
//   cartItems = items.filter((x)=> x.map((y)=> validSkuIds.contains(y.selectedVariant.skuId)));
//   console.log('validcartitems', cartItems);
//   return cartItems;
// }

const customizationOptions = (product) => {
  let loadData = LocalStorageFunc.getLoadDataCart();
  if (!product?.comboUID) {
    let cO = product?.variants;
    return cO;
  } else {
    let cO = product?.groups.map((group) => {
      return {
        ...group,
        items: group.items.map((item) => {
          let productDetail = {};
          loadData.productDefinitions.map((i) => {
            if (i.parentSkuId == item.parentSkuId) {
              i.isVeg = Utility.getIsVegFoodType(i);
              productDetail = i;
            }
          });
          return {
            ...item,
            productDetails: productDetail,
          };
        }),
      };
    });
    return cO;
  }
};

const validComboHasInvalidItems = (
  validItems = [],
  invalidComboProducts = []
) => {
  if (!invalidComboProducts.length) {
    return [];
  } else {
    let validComboList = [];
    validItems.map((item) => {
      if (item?.product?.comboUID) {
        let invalidItemPresent = false;
        item?.product?.groups?.map((group) => {
          group.comboItems.map((cItem) => {
            if (
              invalidComboProducts.filter(
                (product) => product.parentSkuId == cItem.parentSkuId
              ).length > 0
            ) {
              invalidItemPresent = true;
            }
          });
        });
        if (invalidItemPresent) {
          validComboList.push(item?.product?.comboUID);
        }
      }
    });
    return validComboList;
  }
};

const getGlobalUpsellItems = (globalUpsellItems, cartItems) => {
  return globalUpsellItems.map((upsellItem) => {
    let item = { ...upsellItem };
    if (upsellItem.products?.length) {
      item.products = upsellItem.products.filter(
        (product) =>
          !(cartItems[product.parentSkuId] || cartItems[product.skuId])
      );
    }
    return item;
  });
};

export default {
  namespaced: true,
  state: {
    items: LocalStorageFunc.getCart() || {},
    otherTip: 0,
    selectedTip: LocalStorageFunc.getTipAmount() || 0,
    tipAutomaticalySelect:
      LocalStorageFunc.getTipAutomaticallySelected() || false,
    tip: LocalStorageFunc.getTip() || {},
    deliveryInstructions: [],
    deliveryInstructionsChars: 0,
    directionsToReach: "",
    showAdvanceOrderModal: false,
    advanceOrderTimeSlot: {
      date: "",
      time: "",
    },
    directionsToReach: "",
    showItemToastMsg: false,
    itemToastMsg: "",
    cartItemsPriceSet: {},
    cartResponseItemsPriceSet: {},
    cartItemResponse: {},
    lastInteractedProductCard: {},
    cartItemsListingPageIterator: {},
    maxAllowedCharacters: 100,
    tipAmountOptions: [],
    validItems: [],
    inValidItems: [],
    invalidComboProducts: [],
    finalDisplayTotalPrice: "",
    globalUpsellItems: [],
    discount: 0,
    showTipToastMsg: false,
    displayErrorMsg: "",
    comboListWithInvalidItems: [],
    invalidItemsFormatted: [],
    freeItems: {},
    appliedUpsellFilter: "0",
    sgInfo: {},
    showScheduleDelivery: false,
    isDateTimeLoading: false,
    isDateTimeError: false,
    advanceDateTimeData: [],
    sgInfoShimmer: false,
    amountSavedMsg: "",
    cartError: false,
    lastInteractedProductwithUpsellItem: {},
    selectedListUpSellItems:
      LocalStorageFunc.getSelectedListUpSellItems() || {},
  },
  getters: {
    cartTotal: (state) => {
      return getCartTotalFunc(state.items);
    },
    cartQuantity: (state) => {
      let quantity = 0;
      for (const property in state.items) {
        quantity += state.items[property]?.length;
      }
      return quantity;
    },
    validCartQuantity: (state) => {
      let quantity = 0;
      for (const property in state.validItems) {
        quantity += state.validItems[property]?.quantity;
      }
      return quantity;
    },
    lastAddedItemFromCart: (state) => (productId) => {
      let stateItemProductId = state.items[productId];
      return stateItemProductId
        ? stateItemProductId[stateItemProductId?.length - 1]
        : {};
    },
    getCartItems: (state) => {
      return state.items;
    },
    getAppliedUpsellFilter: (state) => {
      return state.appliedUpsellFilter;
    },
    getGlobalUpsellItems: (state) => {
      return getGlobalUpsellItems(state.globalUpsellItems, state.items);
    },
    getSeparateVariants: (state) => (productID) => {
      let itm = state.items[productID];
      if (itm?.[0]?.comboUID) {
        return deDeuplicatedCombos(itm);
      } else if (itm?.[0]?.productMasterUID) {
        return deDuplicatedItems(itm);
      } else return itm;
    },
    getIndividualQuantity: (state) => (productItem) => {
      let q = 0;
      let productItems = state.items[Utility.getProductSkuId(productItem)];

      if (!productItem?.parentSkuId) {
        let itemSelectedComboVariants = new Set();
        let iSelectedComboVariants = [];

        productItem?.selectedComboVariant?.map((comboVariant) => {
          comboVariant?.items?.map((i) =>
            iSelectedComboVariants.push(i?.parentSkuId)
          );
        });
        iSelectedComboVariants.sort();
        iSelectedComboVariants = iSelectedComboVariants.join("");
        itemSelectedComboVariants.add(iSelectedComboVariants);

        productItems?.forEach((pItem) => {
          let iSelectedComboVariants = [];
          pItem?.selectedComboVariant?.map((comboVariant) => {
            comboVariant?.items?.map((i) =>
              iSelectedComboVariants.push(i?.parentSkuId)
            );
          });

          iSelectedComboVariants.sort();
          iSelectedComboVariants = iSelectedComboVariants.join("");

          if (itemSelectedComboVariants.has(iSelectedComboVariants)) {
            q = q + 1;
          }
        });
      } else if (productItem?.parentSkuId) {
        let itemSelectedVariants = new Set();

        itemSelectedVariants.add(productItem.selectedVariant?.skuId);

        productItems?.forEach((pItem) => {
          if (itemSelectedVariants.has(pItem.selectedVariant?.skuId)) {
            q = q + 1;
          }
        });
      }
      return q;
    },

    getCartDetailsForAnalytics: (state) => {
      const validItemList = [];
      const itemQuantity = [];
      const priceList = [];
      const itemIds = [];
      let totalcartQuantity = 0;
      const invalidItemList = [];
      let isInvalidItem = "No";
      let totalCartAmount = "";
      let isComboCart = "No";
      let isVegCart = "Yes";

      const { validItems, invalidItems } = state;

      if (validItems) {
        validItems.forEach((item) => {
          validItemList.push(item.productMetadata.name);
          itemQuantity.push(item.quantity);
          item.calculations.map((calc) => {
            if (calc.key == PRICE_AFTER_DEDUCTIONS_KEY) {
              priceList.push(calc.value);
            }
          });
          itemIds.push(item.skuId);
          totalcartQuantity += item.quantity;
          if (item.isCombo) {
            isComboCart = "Yes";
          }
          if (item.isNonVeg) {
            isVegCart = "No";
          }
        });
      }
      if (invalidItems?.length > 0) {
        isInvalidItem = "Yes";
        invalidItems.forEach((item) => {
          invalidItemList.push(item.productMetadata.name);
          totalcartQuantity += item.quantity;
        });
      }
      const cartDetails = {
        validItems: validItemList.join(","),
        itemIds: itemIds.join(","),
        quantity: itemQuantity.join(","),
        itemPrice: priceList.join(","),
        totalQuantity: totalcartQuantity,
        totalCartAmt: totalCartAmount,
        invalidItemsInCart: isInvalidItem,
        invalidItemsName: invalidItemList.join(","),
        isComboCart,
        isVegCart,
      };
      return cartDetails;
    },
    getCartCalculationsForAnalytics: (state) => {
      const { baseCalculationsMap } = state.cartItemResponse;
      let cartCalc = {};
      baseCalculationsMap &&
        Object.keys(baseCalculationsMap)?.forEach((calc) => {
          cartCalc[baseCalculationsMap[calc].key] =
            baseCalculationsMap[calc].value;
        });
      return cartCalc;
    },
  },
  mutations: {
    updateCartItems(state, payload) {
      state.items = payload;
    },
    updateCartItemsListingPageIterator(state, payload) {
      state.cartItemsListingPageIterator = payload;
    },
    updateLastInteractedProductCard(state, payload) {
      state.lastInteractedProductCard = payload;
    },
    updateLastInteractedProductwithUpsellItem(state, payload) {
      state.lastInteractedProductwithUpsellItem = payload;
    },
    updateSelectedListUpSellItems(state, payload) {
      LocalStorageFunc.setSelectedListUpSellItems(payload);
      state.selectedListUpSellItems = payload;
    },
    updateItemToastMsg(state, payload) {
      state.itemToastMsg = payload;
    },
    updateOfferDiscount(state, payload) {
      state.discount = payload;
    },
    updateAppliedUpsellFilter(state, payload) {
      state.appliedUpsellFilter = payload;
    },
    updateCartError(state, payload) {
      state.cartError = payload;
    },
    updateAmountSavedMsg(state, payload) {
      state.amountSavedMsg = payload;
    },
    updateShowItemToastMsg(state, payload) {
      state.showItemToastMsg = payload;
    },
    updateDirectionsToReach(state, payload) {
      state.directionsToReach = payload;
    },
    updateDeliveryInstructionsChars(state, payload) {
      state.deliveryInstructionsChars = payload;
    },
    updateDeliveryInstructions(state, payload) {
      state.deliveryInstructions = payload;
    },
    updateTipAmountOptions(state, payload) {
      state.tipAmountOptions = payload;
    },
    updateOtherTip(state, payload) {
      state.otherTip = payload;
    },
    updateSgInfoShimmer(state, payload) {
      state.sgInfoShimmer = payload;
    },
    updateAdvanceDateTimeData(state, payload) {
      state.advanceDateTimeData = payload;
    },
    updateSelectedTip(state, payload) {
      state.selectedTip = payload;
    },
    updateCartItemResponse(state, payload) {
      state.cartItemResponse = payload;
    },
    updateTip(state, payload) {
      state.tip = payload;
    },
    updateShowTipToastMsg(state, payload) {
      state.showTipToastMsg = payload;
    },
    updateIsDateTimeLoading(state, payload) {
      state.isDateTimeLoading = payload;
    },
    updateIsDateTimeError(state, payload) {
      state.isDateTimeError = payload;
    },
    updateMaximumAllowedCharacters(state, payload) {
      state.maxAllowedCharacters = payload;
    },
    updateTipAutomaticallySelect(state, payload) {
      state.tipAutomaticalySelect = payload;
      state.tip = { ...state.tip, autoApply: payload };
    },
    updateShowScheduleDelivery(state, payload) {
      state.showScheduleDelivery = payload;
    },
    updateFreeItems(state, payload) {
      let result = [];
      let validItems = payload;
      let loadData = LocalStorageFunc.getLoadDataCart();
      const skuidCount = {};
      let repeatedSkuId = "";
      for (const item of validItems) {
        const { skuId } = item;
        if (skuidCount[skuId]) {
          skuidCount[skuId]++;
        } else {
          skuidCount[skuId] = 1;
        }
      }
      for (const [skuId, count] of Object.entries(skuidCount)) {
        if (count > 1) {
          repeatedSkuId = skuId;
        }
      }
      validItems?.map((x) => {
        if (
          x?.isEffectivelyFree ||
          (x?.calculations?.find((x) => x.key == "price_after_deductions")
            ?.amount === 0 &&
            x.skuId === repeatedSkuId)
        ) {
          if (x?.isCombo) {
            loadData["comboDefinitions"]?.map((y) => {
              if (x.skuId == y.skuId) {
                let selectedComboVariant = [];
                y?.groups?.map((i, index) => {
                  let items = [];
                  x?.childLineItems.map((p) => {
                    let item = i?.items.find(
                      (z) =>
                        z?.parentSkuId == p?.productMetadata?.parentSkuId &&
                        z?.products?.[0]?.skuId == p?.skuId
                    );
                    if (item) {
                      items.push(item);
                    }
                  });
                  let group = Object.assign({}, i);
                  group.items = items;
                  selectedComboVariant.push(group);
                });
                let item = Object.assign({}, y);
                item.isFromCart = true;
                item.isVeg = !x?.nonVeg;
                item.price.currentPrice = x?.product?.price;
                item.selectedComboVariant = selectedComboVariant;
                item.isValid = true;
                item.quantity = x?.quantity;
                item.childLineItems = x?.childLineItems;
                item.itemType = x?.itemType;
                result.push(item);
              }
            });
          } else {
            loadData["productDefinitions"]?.map((y) => {
              if (x?.productMetadata?.parentSkuId == y.parentSkuId) {
                let selectedVariant = {};
                y?.variants?.map((i) => {
                  if (
                    i.productMasterUID == x?.productMetadata?.masterId &&
                    i.productUID == x?.productMetadata?.id
                  ) {
                    i.price.currentPrice = x?.productMetadata?.currentPrice;
                    selectedVariant = i;
                  }
                });
                let item = Object.assign({}, y);
                item.isFromCart = true;
                item.isVeg = !x?.isNonVeg;
                item.selectedVariant = selectedVariant;
                item.isValid = true;
                item.quantity = x?.quantity;
                item.itemType = x?.itemType;
                item.attributes = selectedVariant?.attributes;
                result.push(item);
              }
            });
          }
        }
      });
      state.freeItems = result;
    },
    updateAdvanceOrderTimeSlot(state, payload) {
      state.advanceOrderTimeSlot.date = payload?.date;
      state.advanceOrderTimeSlot.time = payload?.time;
      if (payload?.date?.length || payload?.time?.length) {
        LocalStorageFunc.setAdvanceOrderTimeStampKey(
          state.advanceOrderTimeSlot
        );
      } else {
        LocalStorageFunc.deleteAdvanceOrderTimeStampKey();
      }
    },
    addToCart(state, payload) {
      if (
        getGlobalUpsellItems(state.globalUpsellItems, state.items).filter(
          (_) => _.parentSkuId === payload.parentSkuId
        )?.length > 0
      ) {
        EVENT_CLICK_CARTUPSELL_ADD({ subCategory: payload.displayName });
      }

      state.lastInteractedProductCard = {
        ...state.lastInteractedProductCard,
        productId: Utility.getProductSkuId(payload),
        productName: payload.displayName,
        selectedVariant: payload?.selectedVariant?.displayName || "",
        currentPrice: Utility.getProductCurrentPrice(payload),
      };

      delete payload.quantity;
      if (Array.isArray(state.items[Utility.getProductSkuId(payload)])) {
        state.items[Utility.getProductSkuId(payload)].push({
          ...payload,
          isFromCart: true,
        });
      } else {
        state.items[Utility.getProductSkuId(payload)] = [
          { ...payload, isFromCart: true },
        ];
      }
      LocalStorageFunc.updateCart(state.items);

      if (payload.comboUID) {
        EVENT_CLICK_CUSTOMIZATION_COMBO({ customizationOption: "" });
      } else if (
        payload?.variants?.length > 0 &&
        payload?.variants?.[0].attributes?.length > 0 &&
        !Utility.isCurrentlyAtUrl("/cart")
      ) {
        EVENT_CLICK_CUSTOMIZATION({
          sectionName: payload?.displayName,
          subCategory: payload?.selectedVariant?.displayName,
        });
      }
      if (Utility.isCurrentlyAtUrl("/search/")) {
        EVENT_CLICK_ADDTOCART({
          cartId: LocalStorageFunc.cartId(),
          itemSKU: Utility.getProductSkuId(payload),
          addCounter: state.items[payload.selectedVariant?.skuId]?.length,
          quantity: 1,
          isVegItem: payload.isVeg ? "Veg" : "Non veg",
          itemName: payload.displayName,
          itemOriginalPrice: payload.selectedVariant?.price?.regularPrice,
          price: payload.selectedVariant?.price?.currentPrice,
          itemCategory: payload.parentSkuId,
          isCustomizedItem: payload.selectedVariant?.defaultVariant
            ? "No"
            : "Yes",
          positionWithinSection: getCartTotalFunc(state.items),
        });
      } else {
        EVENT_CLICK_ADDTOCART({
          cartId: LocalStorageFunc.cartId(),
          itemSKU: Utility.getProductSkuId(payload),
          addCounter: state.items[payload.selectedVariant?.skuId]?.length,
          quantity: 1,
          isVegItem: payload.isVeg ? "Veg" : "Non veg",
          itemName: payload.displayName,
          itemOriginalPrice: payload.selectedVariant?.price?.regularPrice,
          price: payload.selectedVariant?.price?.currentPrice,
          itemCategory: payload.parentSkuId,
          isCustomizedItem: payload.selectedVariant?.defaultVariant
            ? "No"
            : "Yes",
          positionWithinSection: getCartTotalFunc(state.items),
        });
      }
      if (payload.comboUID) {
        EVENT_CLICK_COMBO_ADD({
          cartId: LocalStorageFunc.cartId(),
          itemSKU: Utility.getProductSkuId(payload),
          addCounter: state.items[payload.selectedVariant?.skuId]?.length,
          quantity: 1,
          isVegItem: payload.isVeg ? "Veg" : "Non veg",
          itemName: payload.displayName,
          itemOriginalPrice: payload.selectedVariant?.price?.regularPrice,
          price: payload.selectedVariant?.price?.currentPrice,
          itemCategory: payload.parentSkuId,
          isCustomizedItem: payload.selectedVariant?.defaultVariant
            ? "No"
            : "Yes",
          positionWithinSection: getCartTotalFunc(state.items),
        });
      }
    },
    removeFromCart(state, payload) {
      state.lastInteractedProductCard = {
        ...state.lastInteractedProductCard,
        productId: Utility.getProductSkuId(payload),
        productName: payload.displayName,
        selectedVariant: payload?.selectedVariant?.displayName || "",
        currentPrice: Utility.getProductCurrentPrice(payload),
      };

      if (Array.isArray(state.items[Utility.getProductSkuId(payload)])) {
        let index = getIndexOfItemFromCartForRemoval(
          payload,
          state.items[Utility.getProductSkuId(payload)]
        );
        if (
          index > -1 &&
          state.items[Utility.getProductSkuId(payload)].length != 1
        ) {
          state.items[Utility.getProductSkuId(payload)].splice(index, 1);
        } else if (state.items[Utility.getProductSkuId(payload)].length == 1) {
          delete state.items[Utility.getProductSkuId(payload)];
        }
      }
      LocalStorageFunc.updateCart(state.items);
      getGlobalUpsellItems(state.globalUpsellItems, state.items);
      if (Utility.isCurrentlyAtUrl("/search/")) {
        EVENT_CLICK_REMOVEFROMCART({
          positionWithinSection: getCartTotalFunc(state.items),
          itemSKU: Utility.getProductSkuId(payload),
          itemName: payload?.displayName,
          price: Utility.getProductCurrentPrice(payload),
          searchTerm: document.getElementById("searchQueryInputModal").value,
        });
      } else {
        EVENT_CLICK_REMOVEFROMCART({
          positionWithinSection: getCartTotalFunc(state.items),
          itemSKU: Utility.getProductSkuId(payload),
          itemName: payload?.displayName,
          price: Utility.getProductCurrentPrice(payload),
        });
      }
      if (payload.comboUID) {
        EVENT_CLICK_COMBO_REMOVE();
      }
    },
    updateItemInCart(state, payload) {
      if (payload?.item?.comboUID) {
        if (Array.isArray(state.items[Utility.getProductSkuId(payload.item)])) {
          for (let i = 0; i < payload.quantity; i++) {
            let index = getIndexOfItemFromCartForRemoval(
              payload.item,
              state.items[Utility.getProductSkuId(payload.item)]
            );
            state.items[Utility.getProductSkuId(payload.item)][
              index
            ].selectedComboVariant = payload.selectedComboVariant;
            state.items[Utility.getProductSkuId(payload.item)][
              index
            ].customizationOptions = payload.customizationOptions;
            state.items[Utility.getProductSkuId(payload.item)][index].isVeg =
              payload.isVeg;
            LocalStorageFunc.updateCart(state.items);
          }
        }
      } else {
        for (let i = 0; i < payload.quantity; i++) {
          let index = getIndexOfItemFromCartForRemoval(
            payload.item,
            state.items[Utility.getProductSkuId(payload.item)]
          );
          state.items[Utility.getProductSkuId(payload.item)][
            index
          ].selectedVariant = payload.selectedVariant;
          LocalStorageFunc.updateCart(state.items);
        }
        LocalStorageFunc.updateCart(state.items);
      }
      EVENT_CLICK_EDITITEMINCART({});
    },
    loadCartFromStorageService(state, payload) {
      if (Utility.isCurrentlyAtUrl("/cart")) {
        state.items = LocalStorageFunc.getCart();
      } else {
        let cartItems = LocalStorageFunc.getCart();
        Object.values(cartItems)?.map((x) => {
          x &&
            x.length &&
            x?.map((i) => {
              if (i.comboUID) {
                let totalPrice = 0;
                payload["comboDefinitions"]?.map((y) => {
                  if (y.comboUID == i.comboUID) {
                    i?.selectedComboVariant?.map((selectedVariant) => {
                      y?.groups?.map((loadDataVariant) => {
                        if (
                          selectedVariant?.groupUID == loadDataVariant.groupUID
                        ) {
                          selectedVariant?.items?.map((z) => {
                            loadDataVariant?.items?.map((a) => {
                              if (
                                z.products[0].productID ==
                                a.products[0].productID
                              )
                                totalPrice += a.products[0].price.currentPrice;
                            });
                          });
                        }
                      });
                    });
                  }
                });
                i.price.currentPrice = totalPrice;
              }
            });
        });
        state.items = cartItems;
        LocalStorageFunc.updateCart(cartItems);
      }
    },
    showAdvanceOrderModal(state, payload) {
      state.showAdvanceOrderModal = payload;
    },
    updateCartItemsPrice(state, payload) {
      let items = state.items;
      payload?.map((x) => {
        if (x.product?.productMasterId) {
          items[x.product?.productMasterId]?.map((i) => {
            if (i?.selectedVariant?.productUID == x.product.id) {
              i.selectedVariant.price.currentPrice = x.product.price;
            }
          });
        } else if (x.product?.comboUID) {
          //Todo: combo handling to be done once we get cart combo api's
          items[x.product?.comboUID]?.map((i) => {
            if (cartResultItemsPriceSet(x.product)[cartItemsPriceSetKey(i)]) {
              i.price.currentPrice = x.product.price;
            }
          });
        }
      });
      state.items = items;
    },
    updateCartItemsFromGetCart(state, payload) {
      let result = {};
      let loadData = LocalStorageFunc.getLoadDataCart();
      payload?.validItems?.map((x) => {
        if (x?.isCombo) {
          loadData["comboDefinitions"]?.map((y) => {
            if (x?.skuId == y?.skuId) {
              let selectedComboVariant = [];
              y?.groups?.map((i, index) => {
                let items = [];
                x.childLineItems.map((p) => {
                  let item = i.items.find(
                    (z) =>
                      i.groupUID == p.groupId &&
                      z.parentSkuId == p?.productMetadata?.parentSkuId
                  );
                  if (item) {
                    items.push(item);
                  }
                });
                let group = Object.assign({}, i);
                group.items = items;
                selectedComboVariant.push(group);
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.customizationOptions = customizationOptions(item);
              item.isVeg = !x.isNonVeg;
              item.price.currentPrice = x?.calculations?.find(
                (x) => x.key == "current_price"
              )?.amount;
              item.price.regularPrice = x?.calculations?.find(
                (x) => x.key == "regular_price"
              )?.amount;
              item.selectedComboVariant = selectedComboVariant;
              item.isValid = true;
              if (result[y.skuId]) {
                result[y.skuId].push(item);
              } else {
                result[y.skuId] = [item];
              }
            }
          });
        } else {
          loadData["productDefinitions"]?.map((y) => {
            if (x?.productMetadata?.parentSkuId == y?.parentSkuId) {
              let selectedVariant = {};
              y?.variants?.map((i) => {
                if (i?.skuId == x?.skuId) {
                  i.price.currentPrice = x?.calculations?.find(
                    (x) => x.key == "current_price"
                  )?.amount;
                  i.price.regularPrice = x?.calculations?.find(
                    (x) => x.key == "regular_price"
                  )?.amount;
                  selectedVariant = i;
                }
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.isVeg = !x.isNonVeg;
              item.selectedVariant = selectedVariant;
              item.isValid = true;
              if (result[y.parentSkuId]) {
                result[y.parentSkuId].push(item);
              } else {
                result[y.parentSkuId] = [item];
              }
            }
          });
        }
      });
      payload?.inValidItems?.map((x) => {
        if (x?.isCombo) {
          loadData["comboDefinitions"]?.map((y) => {
            if (x?.skuId == y?.skuId) {
              let selectedComboVariant = [];
              y?.groups?.map((i, index) => {
                let items = [];
                x.childLineItems.map((p) => {
                  let item = i.items.find(
                    (z) =>
                      i.groupUID == p.groupId &&
                      z.parentSkuId == p?.productMetadata?.parentSkuId
                  );
                  if (item) {
                    items.push(item);
                  }
                });
                let group = Object.assign({}, i);
                group.items = items;
                selectedComboVariant.push(group);
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.customizationOptions = customizationOptions(item);
              item.isVeg = !x.isNonVeg;
              item.price.currentPrice = x?.calculations?.find(
                (x) => x.key == "current_price"
              )?.amount;
              item.price.regularPrice = x?.calculations?.find(
                (x) => x.key == "regular_price"
              )?.amount;
              item.selectedComboVariant = selectedComboVariant;
              item.isValid = false;
              if (result[y.skuId]) {
                result[y.skuId].push(item);
              } else {
                result[y.skuId] = [item];
              }
            }
          });
        } else {
          loadData["productDefinitions"]?.map((y) => {
            if (x?.productMetadata?.parentSkuId == y?.parentSkuId) {
              let selectedVariant = {};
              y?.variants?.map((i) => {
                if (i?.skuId == x?.skuId) {
                  i.price.currentPrice = x?.calculations?.find(
                    (x) => x.key == "current_price"
                  )?.amount;
                  i.price.regularPrice = x?.calculations?.find(
                    (x) => x.key == "regular_price"
                  )?.amount;
                  selectedVariant = i;
                }
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.isVeg = !x.isNonVeg;
              item.selectedVariant = selectedVariant;
              item.isValid = false;
              if (result[y.parentSkuId]) {
                result[y.parentSkuId].push(item);
              } else {
                result[y.parentSkuId] = [item];
              }
            }
          });
        }
      });
      LocalStorageFunc.updateCart(result);
      state.items = result;
    },
    updateCustomizationOptions(state, payload) {
      let items = state.items;
      Object.values(items).map(
        (x) =>
          x &&
          x.length &&
          x?.map((i) => {
            if (i?.comboUID) {
              i.customizationOptions = customizationOptions(i);
            }
          })
      );
      state.items = items;
      LocalStorageFunc.updateCart(items);
    },
    updateValidItems(state, payload) {
      state.validItems = payload;
    },
    updateInvalidItems(state, payload) {
      state.inValidItems = payload;
    },
    updateInvalidComboProduct(state, payload) {
      state.invalidComboProducts = payload;
    },
    updateCartTotalPrice(state, payload) {
      state.finalDisplayTotalPrice = payload;
    },
    updateGlobalUpsellItems(state, payload) {
      state.globalUpsellItems = payload;
    },
    updateSgInfo(state, payload) {
      state.sgInfo = payload;
    },
    updateDisplayErrorMsg(state, payload) {
      state.displayErrorMsg = payload;
    },
    updateValidComboListWithInvalidItems(state, payload) {
      state.comboListWithInvalidItems = payload;
    },
    updateInvalidItemsFormatted(state, payload) {
      let inValidItems = state.inValidItems;
      let invalidItemsFormatted = [];
      inValidItems?.map((x) => {
        if (x.product?.comboUID) {
          payload["comboDefinitions"].map((y) => {
            if (x.product?.comboUID == y.comboUID) {
              let selectedComboVariant = [];
              y.groups.map((i, index) => {
                let items = [];
                x.product.groups[index].comboItems.map((p) => {
                  let item = i.items.find(
                    (z) =>
                      z.productMasterId == p.productMasterId &&
                      z.products[0].productID == p.productUID
                  );
                  if (item) {
                    items.push(item);
                  }
                });
                let group = Object.assign({}, i);
                group.items = items;
                selectedComboVariant.push(group);
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.isVeg = !x.nonVeg;
              item.price.currentPrice = x.product.price;
              item.selectedComboVariant = selectedComboVariant;
              item.isValid = false;
              invalidItemsFormatted.push(item);
            }
          });
        } else if (x?.product?.productMasterId) {
          payload["productDefinitions"]?.map((y) => {
            if (x?.product?.productMasterId == y.productMasterUID) {
              let selectedVariant = {};
              y?.variants?.map((i) => {
                if (
                  i.productMasterUID == x.product.productMasterId &&
                  i.productUID == x.product.id
                ) {
                  i.price.currentPrice = x.product.price;
                  selectedVariant = i;
                }
              });
              let item = Object.assign({}, y);
              item.isFromCart = true;
              item.isVeg = !x.nonVeg;
              item.selectedVariant = selectedVariant;
              item.isValid = false;
              invalidItemsFormatted.push(item);
            }
          });
        }
      });
      state.invalidItemsFormatted = invalidItemsFormatted;
    },
  },
  actions: {
    getGlobalUpsellItemsApi({ commit, state, rootState }, payload) {
      ApiCalls.GET_GLOABL_UPSELLS_ITEMS_API({
        headers: {
          ...Headers(),
        },
        payload: {
          tenant: "Hongs",
          storeId: Headers()["storeid"],
          channel: "APIKEY",
          channelKey: "AndroidHongs",
        },
      })
        .then(function (response) {
          if (response?.data && response?.data?.data) {
            commit("updateGlobalUpsellItems", response?.data?.data);
          }
        })
        .catch(function (error) {});
    },
    getCartItemsApi({ commit, state, rootState }, payload) {
      ApiCalls.GET_CART_ITEMS_API({
        headers: {
          ...Headers(),
        },
      })
        .then(function (response) {
          if (response?.data) {
            LocalStorageFunc.setCartId(response?.data.cartIdAsString);
            // commit("updateCartItemsFromGetCart", response.data);
            let cartData = Utility.getCartDataInMenuServiceFormat(
              LocalStorageFunc.getCart()
            );
            commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, cartData, {
              root: true,
            });
            commit("updateCustomizationOptions", {
              loadData: payload,
            });
            if (response?.data?.discountAllocations?.[0]?.confettiMessage) {
              commit(
                "updateAmountSavedMsg",
                response?.data?.discountAllocations?.[0]?.confettiMessage
              );
              commit("Offers/updateOfferFailedMsg", "", { root: true });
            }
            commit("updateCartItemResponse", response.data);
            commit(
              "updateTipAmountOptions",
              response.data?.tipsMetadata?.tipMainLayout?.tipsAmountOption
                ?.amountOptions
            );
          }
        })
        .catch(function (error) {});
    },
    updateCartItemsApi({ commit, state, getters }, payload) {
      ApiCalls.UPDATE_CART_ITEMS_API({
        headers: {
          ...Headers(),
        },
        payload: {
          explicitPromo: LocalStorageFunc.getCouponCode().code
            ? [LocalStorageFunc.getCouponCode().code]
            : [],
          tip: LocalStorageFunc.getTip(),
          items: getCartItemsPayload(state.items, getters),
          cartProperties: payload?.cartProperties || [],
        },
      })
        .then(function (response) {
          if (response?.data) {
            LocalStorageFunc.setCartId(response?.data.cartIdAsString);
            if (
              response?.data?.validItems?.length +
                response?.data?.inValidItems?.length !=
              state.items.length
            ) {
              commit("updateFreeItems", response?.data?.validItems);
            }
            commit("updateCartItemsPrice", response.data.validItems);
            if (response?.data?.validItems) {
              commit("updateValidItems", response?.data?.validItems);
              commit(
                "updateValidComboListWithInvalidItems",
                validComboHasInvalidItems(
                  response?.data?.validItems,
                  response?.data?.invalidComboProducts
                )
              );
            }
            if (response?.data?.inValidItems) {
              commit("updateInvalidItems", response?.data?.inValidItems);
            }
            if (response?.data?.invalidComboProducts) {
              commit(
                "updateInvalidComboProduct",
                response?.data?.invalidComboProducts
              );
            }
            if (response?.data?.discountAllocations?.[0]?.confettiMessage) {
              commit(
                "updateAmountSavedMsg",
                response?.data?.discountAllocations?.[0]?.confettiMessage
              );
              commit("Offers/updateOfferFailedMsg", "", { root: true });
            }
            if (
              response?.data?.inValidItems?.length ||
              response?.data?.invalidComboProducts?.length
            ) {
              commit(
                "updateDisplayErrorMsg",
                CartErrorMessages.INVALID_ITEM_MSG
              );
            } else if (response?.data?.status === "FAILED") {
              commit(
                "updateDisplayErrorMsg",
                CartErrorMessages.INVALID_STORE_MSG
              );
            } else {
              commit("updateDisplayErrorMsg", "");
            }
            if (
              response?.data?.baseCalculationsMap?.grand_total?.roundedValue
            ) {
              commit(
                "updateCartTotalPrice",
                response?.data?.baseCalculationsMap?.grand_total?.roundedValue
              );
            }
            if (response?.data?.baseCalculationsMap?.discount?.amount) {
              commit(
                "updateOfferDiscount",
                response?.data?.baseCalculationsMap?.discount?.amount
              );
            }
            if (
              response?.data?.explicitPromo &&
              response?.data?.explicitPromo?.errors
            ) {
              commit(
                "Offers/updateOfferFailedMsg",
                "Invalid promo. " +
                  response?.data?.explicitPromo?.errors[0]?.displayMsg,
                { root: true }
              );
              commit("updateAmountSavedMsg", "");
              commit("Offers/updateShowOfferFailedMsg", true, { root: true });
              setTimeout(() => {
                commit("Offers/updateShowOfferFailedMsg", false, {
                  root: true,
                });
              }, 3000);
            }
            commit("updateCartItemResponse", response.data);
            commit(
              "updateTipAmountOptions",
              response.data?.tipsMetadata?.tipMainLayout?.tipsAmountOption
                ?.amountOptions
            );
            LocalStorageFunc.updateCart(state.items);
            if (payload?.isRedirectToPayment) {
              Utility.redirectToPaymentPage();
            }
          }
        })
        .catch(function (error) {});
    },
    createCartItemsApi({ commit, state, getters, dispatch }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      let payloadObj = {};
      if (
        LocalStorageFunc.getTip() &&
        Object.keys(LocalStorageFunc.getTip()).length
      ) {
        payloadObj = {
          explicitPromo:
            payload?.code || LocalStorageFunc.getCouponCode()?.code
              ? [
                  {
                    code:
                      payload?.code || LocalStorageFunc.getCouponCode()?.code,
                  },
                ]
              : [],
          tip: {
            ...LocalStorageFunc.getTip(),
            autoApply: LocalStorageFunc.getTipAutomaticallySelected(),
          },
          items: getCartItemsPayload(state.items, getters),
          cartProperties: [],
        };
      } else {
        payloadObj = {
          explicitPromo:
            payload?.code || LocalStorageFunc.getCouponCode()?.code
              ? [
                  {
                    code:
                      payload?.code || LocalStorageFunc.getCouponCode()?.code,
                  },
                ]
              : [],
          items: getCartItemsPayload(state.items, getters),
          cartProperties: [],
        };
      }
      ApiCalls.CREATE_CART_ITEMS_API({
        headers: {
          ...Headers(),
          ab_test_variant: ab_test_variant,
        },
        payload: {
          ...payloadObj,
        },
      })
        .then(function (response) {
          if (response?.response?.status >= 500) {
            commit("updateCartError", true);
            return;
          }
          if (response?.data) {
            LocalStorageFunc.setCartId(response?.data.cartIdAsString);
            if (
              response?.data?.validItems?.length +
                response?.data?.inValidItems?.length !=
              state.items.length
            ) {
              commit("updateFreeItems", response?.data?.validItems);
            }
            commit("updateCartItemsPrice", response.data.validItems);
            if (response?.data?.validItems) {
              commit("updateValidItems", response?.data?.validItems);
              commit(
                "updateValidComboListWithInvalidItems",
                validComboHasInvalidItems(
                  response?.data?.validItems,
                  response?.data?.invalidComboProducts
                )
              );
            }
            if (response?.data?.offers?.length) {
              let bestOffer = response?.data?.offers.find((x) => x.applicable);
              bestOffer && Object.keys(bestOffer).length
                ? commit("Offers/updateBestOffer", bestOffer, {
                    root: true,
                  })
                : commit(
                    "Offers/updateBestOffer",
                    {},
                    {
                      root: true,
                    }
                  );
            }
            if (response?.data?.inValidItems) {
              commit("updateInvalidItems", response?.data?.inValidItems);
            }
            if (response?.data?.invalidComboProducts) {
              commit(
                "updateInvalidComboProduct",
                response?.data?.invalidComboProducts
              );
            }
            if (response?.data?.discountAllocations?.[0]?.confettiMessage) {
              commit(
                "updateAmountSavedMsg",
                response?.data?.discountAllocations?.[0]?.confettiMessage
              );
              commit("Offers/updateOfferFailedMsg", "", { root: true });
            }
            if (!response?.data?.offersMetadata?.offerApplication?.disabled) {
              commit("Offers/updateOfferFailedMsg", "", { root: true });
            }
            if (response?.data?.discountAllocations?.[0]?.errors) {
              commit(
                "Offers/updateOfferFailedMsg",
                response?.data?.discountAllocations?.[0]?.errors?.[0]
                  ?.displayMessage,
                { root: true }
              );

              commit("updateAmountSavedMsg", "");
              LocalStorageFunc.setDiscountAllocationError(true);
              // commit("Offers/updateShowOfferFailedMsg", true, { root: true });
              // setTimeout(() => {
              //   commit("Offers/updateShowOfferFailedMsg", false, {
              //     root: true,
              //   });
              // }, 3000);
            } else {
              LocalStorageFunc.setDiscountAllocationError(false);
            }

            // if (
            //   response?.data?.inValidItems?.length ||
            //   response?.data?.invalidComboProducts?.length
            // ) {
            //   commit(
            //     "updateDisplayErrorMsg",
            //     CartErrorMessages.INVALID_ITEM_MSG
            //   );
            // } else
            if (
              response?.data?.status === "FAILED" &&
              !response?.data?.inValidItems?.length
            ) {
              commit(
                "updateDisplayErrorMsg",
                CartErrorMessages.INVALID_STORE_MSG
              );
            } else {
              commit("updateDisplayErrorMsg", "");
            }
            if (
              response?.data?.baseCalculationsMap?.grand_total?.roundedValue
            ) {
              commit(
                "updateCartTotalPrice",
                response?.data?.baseCalculationsMap?.grand_total?.roundedValue
              );
            }
            if (response?.data?.baseCalculationsMap?.discount?.amount) {
              commit(
                "updateOfferDiscount",
                response?.data?.baseCalculationsMap?.discount?.amount
              );
            }
            if (
              response?.data?.explicitPromo &&
              response?.data?.explicitPromo?.errors
            ) {
              commit(
                "Offers/updateOfferFailedMsg",
                "Invalid promo. " +
                  response?.data?.explicitPromo?.errors[0]?.displayMsg,
                { root: true }
              );

              commit("updateAmountSavedMsg", "");
              commit("Offers/updateShowOfferFailedMsg", true, { root: true });
              setTimeout(() => {
                commit("Offers/updateShowOfferFailedMsg", false, {
                  root: true,
                });
              }, 3000);
            }
            commit("updateCartItemResponse", response.data);

            // commit("updateCartItemsFromGetCart", response.data);
            commit(
              "updateTipAmountOptions",
              response.data?.tipsMetadata?.tipMainLayout?.tipsAmountOption
                ?.amountOptions
            );
            if (
              response.data?.tipsMetadata?.tipMainLayout?.autoTipSelected ===
              true
            ) {
              commit("updateTipAutomaticallySelect", true);
            }
            // LocalStorageFunc.updateCart(state.items);
            if (payload?.isRedirectToPayment) {
              Utility.redirectToPaymentPage();
            }
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
          dispatch(
            keyMapsActionPayment.GET_INIT_CART_SPECIFIC_FOR_PAYMENT,
            response,
            {
              root: true,
            }
          );
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    sgInfoApi({ commit }) {
      commit("updateSgInfoShimmer", true);
      ApiCalls.SG_INFO_API({
        headers: {
          ...Headers(),
        },
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateSgInfo", response?.data);
          }
          commit("updateSgInfoShimmer", false);
        })
        .catch(function (error) {
          commit("updateSgInfoShimmer", false);
        });
    },
    adavanceOrderApi({ commit, state, getters }, payload) {
      commit("updateIsDateTimeLoading", true);
      let value = LocalStorageFunc.getCoordsFromRecentLocation();
      ApiCalls.ADVANCE_ORDER_API({
        headers: {
          ...Headers(),
        },
        payload: {
          latitude: value?.coords?.latitude,
          longitude: value?.coords?.longitude,
          // latitude: "28.6037",
          // longitude: "77.2593",
          addressRequired: true,
        },
      })
        .then(function (response) {
          if (response?.data?.advanceStoreTimings?.length) {
            commit(
              "updateAdvanceDateTimeData",
              response?.data?.advanceStoreTimings[0]?.timeSlots?.data
            );
            EVENT_ADVANCE_ORDER_CLICK({
              eventAction: "Date and Time Loaded Successfully",
              eventCategory: "Advance Order",
              subCategory: "Date and Time Selection",
            });
          }
          commit("updateIsDateTimeLoading", false);
        })
        .catch(function (error) {
          commit("updateIsDateTimeError", true);
          if (payload.isReload) {
            EVENT_ADVANCE_ORDER_CLICK({
              eventAction: "Loading Error - Reload Date and Time Selection ",
              eventCategory: "Advance Order",
              subCategory: "Date and Time Selection",
              eventLabel: "Reload",
            });
          } else {
            EVENT_ADVANCE_ORDER_CLICK({
              eventAction: "Loading Error",
              eventCategory: "Advance Order",
              subCategory: "Date and Time Selection",
              eventLabel: "Oh Oh! Something went wrong. Reload",
            });
          }
        });
    },
  },
};
